import { USER_RESET, USER_FETCH_SUCCESS, USER_SET, USER_CREATE_SUCCESS } from "../actionTypes";

const INITIAL_STATE = {
  uid: "",
  first_name: "",
  last_name: "",
  email: "",
  permissions: [],
  created_at: "",
  updated_at: "",
};

export default function UserReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_FETCH_SUCCESS:
    case USER_CREATE_SUCCESS:
      return action.payload;
    case USER_SET:
      return { ...state, ...action.payload };
    case USER_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
}
